<template>
  <div>
    <header class="background-cover">
      <b-row>
        <b-col>
          <b-jumbotron
          header="404"
          class="mt-5 transparent-bg text-center"
          >
            <template v-slot:lead>
              <p>
                <strong>Sorry!</strong>
                It appears the page you were looking for doesn't exist anymore or may have moved.
              </p>
              <div class="text-center">
                <router-link :to="{ name: 'Index' }" class="btn btn-anchor">
                  Return to Dashboard
                </router-link>
              </div>
            </template>
          </b-jumbotron>
        </b-col>
      </b-row>
    </header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      header: '404',
    };
  },
};
</script>

<style scoped>
  header {
    min-height: 70vh;
  }

  h1 {
    font-size: 90px;
    font-weight: 600;
  }

  strong {
    font-weight: bold !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/NotFound.vue